import ButtonSaveSplit, { ButtonSaveType } from '@components/ButtonSaveSplit';
import Button from '@components/Button';
import EditActionButton from '@components/EditActionButton';
import FormActionButtons, { FormCancelButton } from '@components/FormActionButtons';
import { FlexRow } from '@components/FlexRow';
import { FormHeaderProfile } from '@components/FormHeaderProfile';
import { Paper } from '@mui-overrides/Paper/index.style';
import { Grid, Stack } from '@mui/material';
import React from 'react';

type Props = {
    loading: boolean;
    onButtonSplitChange?: (type: ButtonSaveType) => void;
    onSubmit: () => void;
    onCancel: () => void;
    onBack?: () => void;
    setFormState?: (state: 'view' | 'edit') => void;
    formState?: 'view' | 'edit';
    submitText?: string;
    buttonSplitText?: {
        [key in ButtonSaveType]: string;
    };
    cancelDisabled?: boolean;
    hideEdit?: boolean;
    submitDisabled?: boolean;
    cancelText?: string;
    editText?: string;
    children: React.ReactNode;
    formTitle: string;
    formDescription?: string;
    breadcrumbs?: (string | { label: string; href: string })[];
    style?: React.CSSProperties;
};

const FormContainer = ({ formState, setFormState, onBack, onCancel, onSubmit, ...props }: Props) => {
    const isOnboarding = false;

    return (
        <Paper
            style={props.style}
            sx={{
                p: 2,
                boxShadow: '0px 4px 80px 0px rgba(112, 144, 176, 0.14)',
            }}>
            <Stack sx={{
                gap: 1,
                position: 'relative'
            }}>
                <Grid container spacing={1}>
                    <Grid item xs={isOnboarding ? 12 : 8} lg={isOnboarding ? 12 : 9}>
                        <Stack style={{ gap: 8, alignItems: isOnboarding ? 'center' : 'flex-start' }}>
                            <FormHeaderProfile
                                title={props.formTitle}
                                description={props.formDescription}
                                breadcrumbs={props.breadcrumbs}
                            />
                        </Stack>
                    </Grid>
                    {!isOnboarding && !props.hideEdit && (
                        <Stack direction="row" style={{ position: 'absolute', top: 0, right: 0 }}>
                            {formState === 'view' && (
                                <Stack direction="row" spacing={1}>
                                    <EditActionButton
                                        onClick={() => setFormState?.('edit')}
                                        disabled={false}
                                    />
                                </Stack>
                            )}
                        </Stack>
                    )}
                </Grid>
            </Stack>
            <Stack style={{ zIndex: 2 }}>{props.children}</Stack>
            <Stack style={{ zIndex: 1 }}>
                {formState === 'edit' && (
                    <Stack direction="row">
                        <FlexRow
                            sx={{
                                mt: {
                                    xs: 3,
                                    md: 4,
                                },
                                marginLeft: 'auto',
                                justifyContent: isOnboarding ? 'space-between' : 'flex-end',
                                flex: 1,
                            }}>
                            <>
                                {isOnboarding ? (
                                    !!onBack ? (
                                        <Button
                                            onClick={() => {
                                                onBack?.();
                                            }}>
                                            Retour
                                        </Button>
                                    ) : (
                                        <span />
                                    )
                                ) : !!props.onButtonSplitChange ? (
                                    <>
                                        <FormCancelButton
                                            onCancel={() => {
                                                onCancel?.();
                                                setFormState?.('view');
                                            }}
                                            label={props.cancelText || 'Annuler'}
                                            size="small"
                                            disabled={props.cancelDisabled}
                                        />
                                        <ButtonSaveSplit
                                            size="small"
                                            onClick={() => onSubmit()}
                                            onChange={props.onButtonSplitChange}
                                            loading={props.loading}
                                            disabled={props.submitDisabled}
                                            labels={props.buttonSplitText}
                                        />
                                    </>
                                ) : (
                                    <FormActionButtons
                                        onCancel={() => {
                                            onCancel?.();
                                            setFormState?.('view');
                                        }}
                                        onSubmit={onSubmit}
                                        cancelLabel={props.cancelText || 'Annuler'}
                                        submitLabel={props.submitText || 'Enregistrer'}
                                        loading={props.loading}
                                        cancelDisabled={props.cancelDisabled}
                                        submitDisabled={props.submitDisabled}
                                        submitType="button"
                                        size="small"
                                    />
                                )}
                            </>
                        </FlexRow>
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
};

export default FormContainer;
